



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import StepIdTooltip from '@/components/Steps/StepIdTooltip.vue';
import { Step } from '@/interfaces/Step';
import { Module } from '@/interfaces/Module';
import ModuleStepListStepRequiresTabSelectRequirements from '@/views/ModulePage/ModuleStepListStepRequiresTabSelectRequirements.vue';
import EditAttributeDialog from '@/components/Dialogues/EditAttributeDialog.vue';
import axios from 'axios';
import env from '@/env';
import { Attribute } from '@/interfaces/Attribute';

@Component({
  components: {
    EditAttributeDialog,
    ModuleStepListStepRequiresTabSelectRequirements,
    StepIdTooltip
  }
})
export default class ModuleStepListStepAttributesTab extends Vue {
  private showEditAttributeDialog = false;

  private selectedAttribute: Attribute = {} as Attribute;

  handleEditAttributeDialogClose(attribute: Attribute | 'cancel') {
    this.showEditAttributeDialog = false;
    if (attribute === 'cancel') return;
    this.selectedAttribute.global = attribute.global;
    this.selectedAttribute.local = attribute.local;
  }

  private removeAttribute(step: Step, attribute: Attribute) {
    if (!this.module) return;
    const index = step.attributes.indexOf(attribute);
    if (index > -1) {
      step.attributes.splice(index, 1);
    }
  }

  get selectableAttributes() {
    return this.$store.state.all_attributes.filter(
      (attribute: Attribute) =>
        attribute.is_blueprint === this.module.is_blueprint &&
        attribute.cutoverplan_id === this.module.cutoverplan_id
    );
  }

  async changeAttributes() {
    for (let index = 0; index < this.defaultStep.attributes.length; index += 1) {
      const attribute = this.defaultStep.attributes[index];
      if (attribute.is_blueprint && !this.module.is_blueprint) {
        axios
          .post(`${env.backend_url}/attribute/create`, {
            key: attribute.key,
            is_blueprint: this.module.is_blueprint,
            blueprint_id: attribute.id,
            origin_id: this.module.id,
            cutoverplan_id: this.module.cutoverplan ? this.module.cutoverplan.id : null
          })
          .then(({ data: newAttribute }) => {
            if (this.module?.attributes) this.defaultStep.attributes[index] = newAttribute;
            this.$store.commit('addAttribute', newAttribute);
          });
      }
    }
  }

  @Prop()
  restrictedUser!: boolean;

  @Prop()
  step!: Step;

  @Prop()
  module!: Module;

  @Prop()
  defaultStep!: Step;
}
